/* eslint-disable import/prefer-default-export */
import { Application } from '@hotwired/stimulus';

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

export { application };

document.addEventListener('clipboard-copy', (e) => {
  const button = e.target;
  const { copiedText } = button.dataset;

  if (copiedText !== undefined && button.innerText !== copiedText) {
    const originalText = button.innerText;
    button.innerText = copiedText;

    setTimeout(() => { button.innerText = originalText; }, 1000);
  }
});
